<script lang="ts">
	import clsx from 'clsx'
	import type { HTMLAttributes } from 'svelte/elements'

	const {
		class: className,
		noPadding = false,
		topMargin = false,
		children,
		...props
	}: {
		noPadding?: boolean
		topMargin?: boolean
	} & HTMLAttributes<HTMLDivElement> = $props()
</script>

{#snippet content()}
	<div
		class={clsx(
			'container',
			{
				'top-margin': topMargin
			},
			className
		)}
		{...props}
	>
		{#if children}
			{@render children()}
		{/if}
	</div>
{/snippet}

{#if noPadding}
	{@render content()}
{:else}
	<div class="container-padder">
		{@render content()}
	</div>
{/if}

<style>.container {
  width: 100%;
  margin: 0 auto;
}
@media screen and (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}

.top-margin {
  margin-top: 32px;
}

.container-padder {
  padding: 0 24px;
}</style>
